import { JSX, useRef } from 'react';
import { PanelHeader } from '@bg-components/PanelHeader';
import { GameNavigationCard } from '@bg-components/GameNavigationCard';
import classNames from 'classnames';
import {
    t,
    partnerSettingsStore,
    useAnyBetsPlaced,
    useMatchedGameId,
    useMobileView,
    analyticsApi,
    GameId,
} from '@bg-shared';
import { Controls } from './Controls';
import classes from './GameNavigation.module.scss';

interface IGameNavigationProps {
    gamesIdsList?: GameId[];
    title?: string;
    inLobby?: boolean;
}

export const GameNavigation = (props: IGameNavigationProps): JSX.Element => {
    const isMobile = useMobileView();
    const currentGameId = useMatchedGameId();
    const gameIds =
        props.gamesIdsList ||
        partnerSettingsStore.availableGamesIds.filter((id) => id !== currentGameId);

    const cardContainerRef = useRef<HTMLDivElement>();
    const { currentGameHasBets } = useAnyBetsPlaced();

    if (currentGameHasBets) {
        return null;
    }

    const showControls = !isMobile || (isMobile && props.inLobby);

    return (
        <>
            <div
                className={classNames(classes.headerContainer, {
                    [classes.lobby]: props.inLobby,
                })}
            >
                <PanelHeader
                    className={classNames(classes.header, {
                        [classes.lobby]: props.inLobby,
                    })}
                >
                    <strong data-qa="label-other-games">
                        {t.string(props.title || 'other_games')}
                    </strong>
                </PanelHeader>
                {showControls && (
                    <Controls inLobby={props.inLobby} cardContainer={cardContainerRef} />
                )}
            </div>
            <div
                ref={cardContainerRef}
                className={classNames(classes.cardContainer, {
                    [classes.lobby]: props.inLobby,
                })}
            >
                {gameIds.map((id) => (
                    <GameNavigationCard
                        key={id}
                        className={classNames(classes.card, {
                            [classes.lobbyCard]: props.inLobby,
                        })}
                        gameId={id}
                        onClick={() => {
                            analyticsApi.trackOpenGameFromOtherGames();
                        }}
                    />
                ))}
            </div>
        </>
    );
};
